/**
 * Statement import lines (FSD Part 3, TRS-S03). The wiring packet spreads
 * `BANKREC_IMPORT_LINES_ROUTES` beside `BANKREC_ROUTES`.
 *
 * `/bankrec/imports/:id(\d+)/lines` sits under the existing import detail
 * `/bankrec/imports/:id(\d+)`; the extra literal segment keeps them apart.
 * Gated on `bankrec.statement.read`, which is what
 * `GET /bankrec/statement-imports/:id/lines` declares.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BANKREC_PERMISSIONS } from '@/modules/bankrec/permissions'

export function importLinesPath(importId: number): string {
  return `/bankrec/imports/${importId}/lines`
}

export const BANKREC_IMPORT_LINES_ROUTES: RouteRecordRaw[] = [
  {
    path: '/bankrec/imports/:id(\\d+)/lines',
    name: 'bankrec-import-lines',
    component: () => import('@/modules/bankrec/imports/ImportLinesView.vue'),
    meta: {
      titleKey: 'bankrec.routeTitles.importLines',
      permission: BANKREC_PERMISSIONS.statementRead,
    },
  },
]
